import * as React from 'react';
import type { SxProps } from '@mui/material';
import { Avatar, Box, Skeleton, Stack, Typography } from '@mui/material';
import { Buildings as BuildingsIcon } from '@phosphor-icons/react/dist/ssr/Buildings';

import type { Community } from '@/types/v2/community';

interface CommunitySettingsHeaderProps {
  community: Community;
  isLoading: boolean;
  error: Error | null;
  sx?: SxProps;
}

export function CommunitySettingsHeader({
  community,
  isLoading,
  sx,
}: CommunitySettingsHeaderProps): React.JSX.Element {
  if (isLoading) {
    return (
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center', ...sx }}>
        <Skeleton height={48} variant="rounded" width={48} />
        <Stack spacing={0.5}>
          <Skeleton height={24} variant="text" width={200} />
          <Skeleton height={18} variant="text" width={300} />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: 'center', ...sx }}>
      <Avatar
        variant="rounded"
        sx={{ width: 48, height: 48, bgcolor: 'primary.main', fontSize: '1rem', fontWeight: 700 }}
      >
        {community.name ? (
          community.name.split(' ').slice(0, 2).map((w) => w.charAt(0)).join('')
        ) : (
          <BuildingsIcon size={22} />
        )}
      </Avatar>
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
          {community?.name}
        </Typography>
        {community?.address && (
          <Typography variant="body2" color="text.secondary">
            {community.address} {community.city}, {community.state} {community.zip_code}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
